import { Map } from "@evergis/sgis/es/Map";
import { DomPainter } from "@evergis/sgis/es/painters/DomPainter/DomPainter";

export class Automation {
  constructor(private map: Map, private painter: DomPainter) {}

  getView() {
    return {
      extent: this.painter.bbox.projectTo(this.map.crs).coordinates,
      position: this.map.position,
      resolution: this.map.resolution,
      sr: this.map.crs.wkid,
    };
  }
}
